import { useState, useEffect, useRef } from "react";
import type { ViewscreenMode } from "../types/game";

interface Props {
  mode: ViewscreenMode;
  imageUrl: string | null;
}

export function Viewscreen({ mode, imageUrl }: Props) {
  const [imageError, setImageError] = useState(false);
  const [timedOut, setTimedOut] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  // Reset error state when URL changes
  useEffect(() => setImageError(false), [imageUrl]);

  const effectiveUrl = imageUrl && !imageError ? imageUrl : null;

  // After 12s in hail mode with no working image, switch to "AUDIO ONLY"
  useEffect(() => {
    if (mode.mode === "hail" && !effectiveUrl) {
      setTimedOut(false);
      timerRef.current = setTimeout(() => setTimedOut(true), 12000);
      return () => clearTimeout(timerRef.current);
    }
    setTimedOut(false);
  }, [mode.mode, effectiveUrl]);

  if (effectiveUrl) {
    return (
      <div className="viewscreen">
        <img src={effectiveUrl} alt="Incoming transmission" onError={() => setImageError(true)} />
        <div className="viewscreen-overlay">
          {mode.mode === "hail" && (
            <span className="viewscreen-label">INCOMING TRANSMISSION</span>
          )}
        </div>
      </div>
    );
  }

  if (mode.mode === "hail") {
    return (
      <div className="viewscreen viewscreen-hail">
        <div className="viewscreen-stars">
          {Array.from({ length: 40 }).map((_, i) => (
            <div
              key={i}
              className="star"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
                animationDuration: `${2 + Math.random() * 3}s`,
              }}
            />
          ))}
        </div>
        <div className="viewscreen-status">
          <span className="viewscreen-status-type">{timedOut ? "AUDIO ONLY" : "HAIL OPEN"}</span>
          <span className="viewscreen-status-desc">
            {timedOut ? "Visual link unavailable" : "Establishing visual link..."}
          </span>
        </div>
      </div>
    );
  }

  return null;
}
